import React from 'react';
import About from 'components/commercetools-ui/organisms/about';

const AboutTastic = () => {
  return <About />;
};

export default AboutTastic;
